import type React from "react";
import {Checkbox, IconButton, Tooltip} from "@mui/material";
import {CloseOutlined} from "@mui/icons-material";
import {formatEur} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Format.ts";

type Props = {
    title: string;
    subtitle?: string | null;
    value?: number | null;
    done: boolean;
    busy?: boolean;
    onToggle: () => void;
    /** User-added items can be removed from the plan. */
    onRemove?: () => void;
    /** The item's savings-initiative control. */
    initiative?: React.ReactNode;
};

export const PtV2ActionItem: React.FC<Props> = ({title, subtitle, value, done, busy, onToggle, onRemove, initiative}) => (
    <div className={'ptv2-task' + (done ? ' is-done' : '')}>
        <Checkbox size="small" checked={done} disabled={busy} onChange={onToggle}
                  slotProps={{input: {'aria-label': `Mark done: ${title}`}}}/>
        <div className="ptv2-task-main">
            <div className="ptv2-task-t">{title}</div>
            {subtitle && <div className="ptv2-task-s">{subtitle}</div>}
        </div>
        {initiative}
        {value != null && <span className="ptv2-task-v ptv2-good ptv2-num">{formatEur(value)}</span>}
        {onRemove && <Tooltip title="Remove from plan">
            <span>
                <IconButton size="small" aria-label={`Remove ${title}`} disabled={busy} onClick={onRemove}>
                    <CloseOutlined fontSize="small"/>
                </IconButton>
            </span>
        </Tooltip>}
    </div>
);
